<div class="vault-item-picker">
  <!-- Toolbar -->
  <div class="atmos-card__header vault-item-picker__header">
    <h2 class="atmos-section__title">Items</h2>
    <div class="vault-item-picker__header-actions">
      <button type="button" class="atmos-btn atmos-btn--sm" (click)="toggleItemSize()">
        <mat-icon>{{ itemSize() === 'small' ? 'zoom_in' : 'zoom_out' }}</mat-icon>
        <span>{{ itemSize() === 'small' ? 'Large icons' : 'Small icons' }}</span>
      </button>
      <button type="button" class="atmos-btn atmos-btn--sm atmos-btn--danger" (click)="reset()">
        <mat-icon>delete_forever</mat-icon>
        <span>Reset</span>
      </button>
    </div>
  </div>

  <!-- Search -->
  <div class="vault-item-picker__search-row">
    <div class="vault-search">
      <mat-icon class="vault-search__icon">search</mat-icon>
      <input #searchInput class="atmos-input atmos-input--pill vault-search__field" type="search"
        (input)="search(searchInput.value)" placeholder="Search items…">
    </div>
  </div>

  <!-- Selection preview (sticky) -->
  <div class="selection-sticky">
    <div class="selection-inner">
      <div class="selection-icons">
        @for (type of selectionTypes; track type) {
          @let item = selection()[type];
          <div class="selection-icon"
            (click)="gotoType(type)"
            [class.selected]="item"
            [class.warn]="requiredParams[type] && !item"
            skyTooltip="{{ item?.name || (type | itemType) }}">
            @if (item) {
              <app-item-icon [item]="item" [size]="'default'" class="selection-icon-img"
                [opaque]="true"></app-item-icon>
            } @else {
              <mat-icon [svgIcon]="itemIcons[type]" class="selection-icon-img"></mat-icon>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Item grid -->
  <div class="closet-grid atmos-scroll-x">
    @for (section of sections; track $index) {
      @if ($index > 0) {
        <div class="closet-grid-section-divider"></div>
      }
      <div class="closet-grid-section" [class.section-folded]="sectionFolded()[$index]">
        @for (type of section; track type) {
          <div class="closet-items" [attr.data-type]="type"
            [style.grid-template-columns]="'repeat(' + columns + ', ' + (itemSizePx()+8) + 'px)'">
            <!-- Type header -->
            <div [style.gridColumn]="'1/' + (columns+1)" class="closet-type" (click)="foldType(type)">
              <mat-icon [svgIcon]="itemIcons[type]"></mat-icon>
              <div class="closet-type-fold">
                <mat-icon>{{ typeFolded()[type] ? 'add' : 'remove' }}</mat-icon>
              </div>
            </div>
            <!-- Items -->
            @for (item of items[type]; track item.guid) {
              <div class="closet-item-container" [hidden]="typeFolded()[type]">
                <div class="closet-item"
                  (click)="selectItem(item)"
                  [attr.data-guid]="item.guid"
                  [class.selected]="selectionMap()[item.guid]"
                  [class.search-match]="searchText() && searchResults()?.[item.guid]"
                  [class.no-search-match]="searchText() && !searchResults()?.[item.guid]"
                  [skyTooltip]="item.name">
                  <app-item-icon [item]="item" [size]="itemSize()"
                    [opaque]="true"></app-item-icon>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
